import React, { useState, useRef } from "react";
import { Popover } from "@mui/material";
import "./FilterableHeader.scss";

export default function FilterableHeader({
  title,
  onClear,
  isFilterApplied = false,
  children,
}) {
  const [hover, setHover] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const childRef = useRef(null);

  const handleFilterClick = (e) => {
    e.stopPropagation();
    setAnchorEl(anchorEl ? null : e.currentTarget);
  };

  const open = Boolean(anchorEl);

  const handleClear = () => {
    childRef.current?.clear?.();
    onClear?.();
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div
      className="filterable-header"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className="data-tag-filter-header-title">{title}</div>

      {(hover || open || isFilterApplied) && (
        <div
          className={`header-filter-icon ${
            open || isFilterApplied ? "active" : ""
          }`}
          onClick={handleFilterClick}
        >
          <img
            src="/sysGuardIcons/filter_list_notSelected.svg"
            alt="Filter"
            className="filter-img"
          />
        </div>
      )}

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        disableScrollLock
        PaperProps={{ className: "filter-popover-paper" }}
      >
        <div className="filter-content-container">
          <div className="filter-content">
            {children && React.cloneElement(children, { ref: childRef })}
          </div>

          <div className="filter-actions">
            <button className="btn-clear" onClick={handleClear}>
              Clear
            </button>
          </div>
        </div>
      </Popover>
    </div>
  );
}
